function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { getAuthToken } from 'granite-admin/utils/auth-singleton';
import LinearLayout from 'granite-admin/core/components/LinearLayout';
const PublicOnlyRoute = ({
  component: Component,
  ...rest
}) => {
  return /*#__PURE__*/React.createElement(Route, _extends({}, rest, {
    render: props => {
      const authToken = getAuthToken();
      if (authToken) {
        // ONLY non-logged in users are allowed to access this route.
        return /*#__PURE__*/React.createElement(Redirect, {
          to: {
            pathname: '/dashboard'
          }
        });
      }
      // authorised so return component
      return /*#__PURE__*/React.createElement(LinearLayout, null, /*#__PURE__*/React.createElement(Component, props));
    }
  }));
};
export default PublicOnlyRoute;